import { ArrowRight } from "lucide-react";
import { ConfirmDelete, EmptyState, TABLE_HEAD, TABLE_ROW } from "./common";
import { dateTimeFmt, money, qtyFmt } from "../lib/api";

const TYPE_STYLE = {
  stock_in: ["Stock In", "text-blue-400 bg-blue-500/10 border-blue-500/20"],
  stock_out: ["Sale", "text-emerald-400 bg-emerald-500/10 border-emerald-500/20"],
  transfer: ["Transfer", "text-amber-400 bg-amber-500/10 border-amber-500/20"],
};

export function TypeBadge({ type }) {
  const [label, cls] = TYPE_STYLE[type] || [type, ""];
  return <span className={`inline-flex rounded border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${cls}`}>{label}</span>;
}

export function MovementTable({ rows, onVoid, showType = false, testid = "movement-table" }) {
  if (!rows?.length) return <EmptyState text="No entries yet" testid={`${testid}-empty`} />;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead className={TABLE_HEAD}>
          <tr>
            <th className="px-4 py-2.5 text-left">Time</th>
            {showType && <th className="px-4 py-2.5 text-left">Type</th>}
            <th className="px-4 py-2.5 text-left">Product</th>
            <th className="px-4 py-2.5 text-left">Depot</th>
            <th className="px-4 py-2.5 text-right">Qty</th>
            <th className="px-4 py-2.5 text-right">Total</th>
            <th className="px-4 py-2.5 text-left">Party / Pay</th>
            <th className="px-4 py-2.5 text-left">By</th>
            {onVoid && <th className="px-2 py-2.5" />}
          </tr>
        </thead>
        <tbody>
          {rows.map((m) => (
            <tr key={m.id} className={TABLE_ROW} data-testid={`movement-row-${m.id}`}>
              <td className="px-4 py-2.5 font-mono text-xs text-slate-400 whitespace-nowrap">{dateTimeFmt(m.created_at)}</td>
              {showType && <td className="px-4 py-2.5"><TypeBadge type={m.type} /></td>}
              <td className="px-4 py-2.5">
                <div className="font-medium text-slate-100">{m.product_name}</div>
                <div className="font-mono text-[11px] text-slate-500">{m.sku}</div>
              </td>
              <td className="px-4 py-2.5 text-slate-300 whitespace-nowrap">
                {m.type === "transfer" ? (
                  <span className="inline-flex items-center gap-1">{m.depot_name}<ArrowRight className="h-3 w-3 text-amber-500" />{m.to_depot_name}</span>
                ) : m.depot_name}
              </td>
              <td className="px-4 py-2.5 text-right font-mono">{qtyFmt(m.qty)} <span className="text-slate-500 text-xs">{m.unit}</span></td>
              <td className={`px-4 py-2.5 text-right font-mono ${m.type === "stock_out" ? "text-emerald-400" : m.type === "stock_in" ? "text-rose-400" : "text-slate-500"}`}>
                {m.type === "transfer" ? "—" : money(m.total)}
              </td>
              <td className="px-4 py-2.5 text-slate-400 text-xs">
                <div>{m.party || (m.note ? m.note : "—")}</div>
                {m.payment_method && <div className="text-slate-500">{m.payment_method}{m.due_date ? ` · due ${m.due_date}` : ""}</div>}
              </td>
              <td className="px-4 py-2.5 text-xs text-slate-400 whitespace-nowrap">{m.user_name}</td>
              {onVoid && (
                <td className="px-2 py-2.5">
                  <ConfirmDelete
                    title="Void this entry?"
                    description="The entry will be removed and stock levels reversed. This cannot be undone."
                    onConfirm={() => onVoid(m.id)}
                    testid={`void-movement-${m.id}`}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
